export const bookCoverList = [
  { src: '/img/covers/c_01.jpg' },
  { src: '/img/covers/c_02.jpg' },
  { src: '/img/covers/c_03.jpg' },
]
